import { memo, ReactNode } from "react"

import cssModule from "./index.module.scss"

export type FooterProps = {
	content?: ReactNode
}

export const Footer = memo(function Footer({ content }: FooterProps) {
	return content && (
		<footer className={cssModule.footer}>
			{content}
			<div className={cssModule.copyright}>
				<span>&copy; Управление цифровизации (УЦ) КемГУ</span>
			</div>
		</footer>
	)
})
